import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import swal from "sweetalert";
import axios from "axios";

const Onlinestore = () => {
  // ====================modal====================
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // ====================modal====================

  let [allonline, updateOnline] = useState([]);

  // ===================calling form ====================

 
  let [image, pickImg] = useState("");
  let [title, pickTitle] = useState("");
  let [description, pickDescription] = useState("");
  let [fileurl, pickUrl] = useState("");

  // ===================calling form ====================

  // ======================getdetail=============


  const getOnline = () => {
    axios.get('http://localhost:1234/OnlineStore')
      .then((response) => {
        const empData = response.data;
        updateOnline(empData);
      })
      .catch((error) => {
        console.error('Error fetching data: ', error);
      });
  };

  // ======================getdetail=============

  useEffect(() => {
    getOnline();
  }, [1]);

  //  ===========================save======================

  const save = () => {
    if (onlineid === 0) {
      let url = "http://localhost:1234/OnlineStore";
      let onlineinfo = {
        "image": image,
        "title": title,
        "desc": description,
        "url": fileurl,
      };

      axios
        .post(url, onlineinfo) // Use Axios post method
        .then((response) => {
          swal(title, "Save Successfully", "success");
          pickImg("");
          pickTitle("");
          pickDescription("");
          pickUrl("");
          getOnline();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      let url = `http://localhost:1234/OnlineStore/${onlineid}`;

      let onlineinfo = {
        "image": image,
        "title": title,
        "desc": description,
        "url": fileurl,
      };

      axios
        .patch(url, onlineinfo) // Use Axios patch method for update
        .then((response) => {
          swal(title, "Update Successfully", "success");
          pickImg("");
          pickTitle("");
          pickDescription("");
          pickUrl("");
          getOnline();
          updateOn(0);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  };

  //  ===========================save======================

  const delonline = (id, title) => {
    let url = `http://localhost:1234/OnlineStore/${id}`;

    axios
      .delete(url) // Use Axios delete method
      .then((response) => {
        swal(title, "Deleted Successfully", "success");
        getOnline();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };


  let [onlineid, updateOn] = useState(0);
  let [mybtn, updateBtn] = useState("Save ");

  const editCategory = (index) => {
    updateOn(allonline[index].id);
    updateBtn("Update ");

    pickTitle(allonline[index].title);
    pickImg(allonline[index].image);
    pickDescription(allonline[index].desc);
    pickUrl(allonline[index].url);
  };

  return (
    <section>
      <div className="container-fluid mt-4">
        <div className="row">
          <div className="col-lg-1 text-end">
            <Link to="/">
              <h6>
                <i class="fa fa-home" aria-hidden="true"></i>Home
              </h6>
            </Link>
          </div>
          /
          <div className="col-lg-5">
            <h6>OnlineStore</h6>
          </div>
          <div className="col-lg-10 mt-3 mb-3">
            <div className="card border-0 shadow ">
              <div className="card-header bg bg-info border-0">
                <h4>List Of OnlineStore</h4>
              </div>

              <div className="card-body">
                <div className="col-lg-12 ">
                  <div className="row text-end">
                    <div className="col-lg-6"></div>
                    <div className="col-lg-3"></div>

                    <div className="col-lg-3">
                      <button
                        className="btn btn-success"
                        variant="primary"
                        onClick={handleShow}
                      >
                        Create New OnlineStore
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 mt-3">
                  <div class="table-responsive">
                    <table class="table table-bordered  mb-0 text-nowrap">
                      <thead>
                        <tr>
                          <th> Sl.No </th>
                          <th>Image</th>
                          <th>Title</th>
                          <th> Description</th>
                          <th> Url</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {/* ==================================map ============================= */}

                        {
                          allonline.map((online, index) => {
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                <img src={online.image} className="img-fluid" />
                              </td>
                              <td>{online.title}</td>
                              <td>{online.desc}</td>
                              <td>{online.url}</td>
                              <td>
                              <button
                                  onClick={function () {
                                    editCategory(index);
                                    handleShow();
                                  }.bind(this)}
                                >
                                  Edit
                                </button>
                                <button onClick={delonline.bind(this,online.id,online.title)}> Delete </button>
                              </td>
                            </tr>
                          );
                        })
                        }

                        {/* ==================================map================================== */}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ========================modal start=============== */}

      <div
        className="modal show"
        style={{ display: "block", position: "initial" }}
      >
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Onlinestore</Modal.Title>
          </Modal.Header>
          <Modal.Body>
           
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Image</Form.Label>
              <Form.Control
                type="file"
                onChange={obj=> pickImg(obj.target.value)}
                value={image}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Title"
                onChange={obj => pickTitle(obj.target.value)}
                value={title}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Description</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Description"
                onChange={obj => pickDescription(obj.target.value)}
                value={description}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Url</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter url"
                onChange={obj => pickUrl(obj.target.value)}
                value={fileurl}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary"  onClick={() => {
  save();
  handleClose();}}>
              {mybtn}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </section>
  );
};

export default Onlinestore;
